import { render, staticRenderFns } from "./ShipmentCreationRuleLogs.vue?vue&type=template&id=59941d28"
import script from "./ShipmentCreationRuleLogs.vue?vue&type=script&lang=js"
export * from "./ShipmentCreationRuleLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports